import React, { useState } from "react";

//  Images

// Libs
import { Modal, Accordion } from "react-bootstrap";
import { navigate } from "gatsby";
import { imageUrl } from "../actions/miscAction";

const leftArrowIcon = imageUrl("chevron-left-angle.svg");

const MobileDropdown = (props) => {
  //  States
  const [tab, setTab] = useState(1);

  const redirectToSearch = (event, url) => {
    event.preventDefault();
    navigate(url);
  };

  const { allCategoryListHome, allRegionsHome, allTopManufacturer } = props.data;

  return (
    <Modal
      className={"modal left-collapse fade"}
      show={props.showModal}
      onHide={props.toggleModal}
      id="browseCollapse"
      tabindex="-1"
      role="dialog"
    >
      <div class="filter-collapse-content">
        <div className="fcc-header d-flex align-items-center justify-content-between">
          <div class="close" data-bs-dismiss="modal" aria-label="Close" onClick={props.toggleModal}>
            <img src={leftArrowIcon} alt="leftArrowIcon" />
          </div>
          <h3 class="fcc-title" id="myModalLabel">
            Browse
          </h3>
        </div>
        <div className="fcc-body p-0">
          <div class="fcc-tab-container d-flex">
            <div class="nav flex-column nav-pills" id="v-pills-tab" role="tablist" aria-orientation="vertical">
              <a
                class={`nav-link ${tab === 1 && "active"}`}
                id="v-pills-tab-A-tab"
                data-bs-toggle="pill"
                data-bs-target="#v-pills-pane-A"
                role="tab"
                aria-controls="v-pills-tab-A"
                aria-selected="true"
                onClick={(e) => {
                  e.preventDefault();
                  setTab(1);
                }}
              >
                Category
              </a>
              <a
                class={`nav-link ${tab === 2 && "active"}`}
                id="v-pills-tab-B-tab"
                data-bs-toggle="pill"
                data-bs-target="#v-pills-pane-B"
                role="tab"
                aria-controls="v-pills-tab-B"
                aria-selected="false"
                onClick={(e) => {
                  e.preventDefault();
                  setTab(2);
                }}
              >
                Region
              </a>
              <a
                class={`nav-link ${tab === 3 && "active"}`}
                id="v-pills-tab-C-tab"
                data-bs-toggle="pill"
                data-bs-target="#v-pills-pane-C"
                role="tab"
                aria-controls="v-pills-tab-C"
                aria-selected="false"
                onClick={(e) => {
                  e.preventDefault();
                  setTab(3);
                }}
              >
                Manufacturer
              </a>
            </div>
            <div class="tab-content" id="v-pills-tabContent">
              <div class={`tab-pane fade ${tab === 1 && "show active"}`} id="v-pills-pane-A" role="tabpanel">
                <div class="tab-content-box">
                  <Accordion>
                    {" "}
                    {allCategoryListHome &&
                      allCategoryListHome.length > 0 &&
                      allCategoryListHome.map((ec, i) =>
                        ec.subCategories && ec.subCategories.length > 0 ? (
                          <Accordion.Item eventKey={`${i + 1}`}>
                            <Accordion.Header>
                              {ec.description} ({ec.auctions})
                            </Accordion.Header>

                            <Accordion.Body>
                              <ul>
                                {ec.subCategories.map((esc) => (
                                  <li>
                                    <a
                                      href="javascript:void(0)"
                                      onClick={(event) => {
                                        event.preventDefault();
                                        props.toggleModal();
                                        navigate(`/listings/index.cfm/catid/${esc.category_id}`);
                                      }}
                                    >
                                      {esc.description} ({esc.auctions})
                                    </a>
                                  </li>
                                ))}
                              </ul>
                              <a
                                href="javascript:void(0)"
                                class="viewall_btn"
                                data-bs-toggle="modal"
                                data-bs-target="#subCatModal"
                                onClick={(event) => {
                                  event.preventDefault();
                                  props.toggleModal();
                                  if (ec.description === "Pipe") {
                                    navigate(`/pipe`);
                                  } else navigate(`/listings/index.cfm/catid/${ec.category_id}`);
                                }}
                              >
                                View all
                              </a>
                            </Accordion.Body>
                          </Accordion.Item>
                        ) : (
                          <p
                            style={{ padding: "10px 20px" }}
                            class="para-item mb-0"
                            onClick={(e) =>
                              ec.description === "Pipe"
                                ? navigate(`/pipe`)
                                : navigate(`/listings/index.cfm/catid/${ec.category_id}`)
                            }
                          >
                            {ec.description} {`(${ec.auctions})`}
                          </p>
                        ),
                      )}
                  </Accordion>
                </div>
              </div>
              <div class={`tab-pane fade ${tab === 2 && "show active"}`} id="v-pills-pane-B" role="tabpanel">
                <div class="tab-content-box region-box">
                  <Accordion>
                    {" "}
                    {allRegionsHome &&
                      allRegionsHome.length > 0 &&
                      allRegionsHome.map(
                        (ec, i) =>
                          ec.geoRegion === "North America" && (
                            <Accordion.Item eventKey={`${i + 1}`}>
                              <Accordion.Header
                                onClick={(e) =>
                                  !ec.subRegion.length
                                    ? redirectToSearch(e, `/listings/index.cfm/georegionid/${ec.geoRegionID}`)
                                    : null
                                }
                              >
                                {"United States"} {`(${ec.auctions})`}
                              </Accordion.Header>
                              <Accordion.Body key={ec.description}>
                                <ul>
                                  <li>
                                    <a
                                      class="viewall_btn"
                                      href="javascript:void(0)"
                                      onClick={(event) =>
                                        redirectToSearch(event, `/listings/index.cfm/regid/${ec.geoRegionID}`)
                                      }
                                    >
                                      View All
                                      {` (${ec.auctions})`}
                                    </a>
                                  </li>
                                  {ec.subRegion.map((esc) => (
                                    <li>
                                      <a
                                        href="javascript:void(0)"
                                        onClick={(event) =>
                                          redirectToSearch(event, `/listings/index.cfm/regid/${esc.region_id}`)
                                        }
                                      >
                                        {esc.description} ({esc.auctions})
                                      </a>
                                    </li>
                                  ))}
                                </ul>
                              </Accordion.Body>
                            </Accordion.Item>
                          ),
                      )}
                    {allRegionsHome &&
                      allRegionsHome.length > 0 &&
                      allRegionsHome.map(
                        (ec, i) =>
                          ec.geoRegion != "North America" && (
                            <Accordion.Item eventKey={`${i + 1}`}>
                              <Accordion.Header
                                onClick={(e) =>
                                  !ec.subRegion.length
                                    ? redirectToSearch(e, `/listings/index.cfm/georegionid/${ec.geoRegionID}`)
                                    : null
                                }
                              >
                                {`${ec.geoRegion}`} {`(${ec.auctions})`}
                              </Accordion.Header>
                              <Accordion.Body key={ec.description}>
                                <ul>
                                  <li>
                                    <a
                                      class="viewall_btn"
                                      href="javascript:void(0)"
                                      onClick={(event) =>
                                        redirectToSearch(event, `/listings/index.cfm/regid/${ec.geoRegionID}`)
                                      }
                                    >
                                      View All
                                      {` (${ec.auctions})`}
                                    </a>
                                  </li>
                                  {ec.subRegion.map((esc) => (
                                    <li>
                                      <a
                                        href="javascript:void(0)"
                                        onClick={(event) =>
                                          redirectToSearch(event, `/listings/index.cfm/regid/${esc.region_id}`)
                                        }
                                      >
                                        {esc.description} ({esc.auctions})
                                      </a>
                                    </li>
                                  ))}
                                </ul>
                              </Accordion.Body>
                            </Accordion.Item>
                          ),
                      )}
                  </Accordion>
                </div>
              </div>
              <div class={`tab-pane fade ${tab === 3 && "show active"}`} id="v-pills-pane-C" role="tabpanel">
                <div class="tab-content-box">
                  <Accordion>
                    {" "}
                    {allTopManufacturer &&
                      allTopManufacturer.length > 0 &&
                      allTopManufacturer.map((ec, i) =>
                        ec.subManufacturers && ec.subManufacturers.length > 0 ? (
                          <Accordion.Item eventKey={`${i + 1}`}>
                            <Accordion.Header>
                              {ec.description} ({ec.auctions})
                            </Accordion.Header>

                            <Accordion.Body>
                              <ul>
                                {ec.subManufacturers.map((esc) => (
                                  <li>
                                    <a
                                      href="javascript:void(0)"
                                      onClick={(event) => {
                                        event.preventDefault();
                                        props.toggleModal();
                                        navigate(`/listings/index.cfm/catid/${ec.category_id}/mfr/${esc.mfrid}`);
                                      }}
                                    >
                                      {esc.description} ({esc.auctions})
                                    </a>
                                  </li>
                                ))}
                              </ul>
                              <a
                                href="javascript:void(0)"
                                class="viewall_btn"
                                data-bs-toggle="modal"
                                data-bs-target="#subCatModal"
                                onClick={(event) => {
                                  event.preventDefault();
                                  props.toggleModal();
                                  if (ec.description === "Pipe") {
                                    navigate(`/pipe`);
                                  } else navigate(`/listings/index.cfm/catid/${ec.category_id}`);
                                }}
                              >
                                View all
                              </a>
                            </Accordion.Body>
                          </Accordion.Item>
                        ) : (
                          <p
                            style={{ padding: "10px 20px" }}
                            class="para-item mb-0"
                            onClick={(e) =>
                              ec.description === "Pipe"
                                ? navigate(`/pipe`)
                                : navigate(`/listings/index.cfm/catid/${ec.category_id}`)
                            }
                          >
                            {ec.description} {`(${ec.auctions})`}
                          </p>
                        ),
                      )}
                  </Accordion>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default MobileDropdown;
